import * as React from 'react';
import Icon from 'react-native-vector-icons/AntDesign'
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import { redBorderInputColor } from '../../colors';

const ErrorAgreement = (props) => props.error && <View style={styles.erroragreement}> 
                <Text style={styles.textError}> 
                    <Icon style={styles.alertIcon} name='exclamationcircle'> </Icon>
                    {props.error}
                </Text>
            </View>

export default ErrorAgreement;

const styles = StyleSheet.create({
    erroragreement: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
    },
    textError: {
        color: redBorderInputColor,
        fontSize: 12,
        marginTop: -30,
    },
    alertIcon: {
        paddingRight: 3,
    },
})
